import { createAsyncThunk } from '@reduxjs/toolkit';
import { getLastSync as getLastSyncApi } from 'api/rest/integrations/jamf/sync';
import { SyncData } from 'api/rest/integrations/jamf/sync/types';

export const getLastSync = createAsyncThunk<SyncData, string>(
  'jamf/sync/getLastSync',
  async (orgId: string) => {
    return getLastSyncApi(orgId);
  }
);

export const startSync = createAsyncThunk<SyncData, string>(
  'jamf/sync/startSync',
  async (orgId: string) => {
    // Implement this when the API function is available
    return getLastSyncApi(orgId);
  }
); 
